// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { css } from "styled-components";
import { fetch } from "@insite/client-framework/ServerSideRendering";

interface OwnProps {
    url: string;
    number?: number;
}

export interface PartFinderSchemaSvg {
    container?: InjectableCss;
}

export const partFinderSchemaSvg: PartFinderSchemaSvg = {
    container: {
        css: css`
            border: ${pxToRem(1)} solid ${getColor("common.border")};
            margin-bottom: ${pxToRem(15)};
            padding: ${pxToRem(15)};
            min-height: 75vh;
        `,
    },
};

const styles = partFinderSchemaSvg;

interface HotspotsProps {
    styles: string;
}

const Hotspots = styled.div<HotspotsProps>`
    ${props => props.styles}
`;

export const PartFinderSchemaSvg = ({ url, number }: OwnProps) => {
    const ref = useRef<HTMLImageElement>(null);
    const hotspotsCss = `
    .hotspot_${number} {
        fill: transparent;
        stroke: #0c8fd5;
        visibility: visible;
    }`;
    useEffect(() => {
        (async function () {
            const data = await fetch(url);
            const svgHtml = await data.text();

            if (ref.current) {
                ref.current.outerHTML = svgHtml;
            }
        })();
    }, [url]);

    return (
        <StyledWrapper {...styles.container}>
            <Hotspots styles={hotspotsCss}>
                <img ref={ref} src={url} alt="" />
            </Hotspots>
        </StyledWrapper>
    );
};
